import React, { useState } from "react";
import { Container, Table, Row, Col } from "react-bootstrap";
import NavigationBar from "../ReusableComp/NavigationBar";
import { tableData } from "../ReusableComp/UserManuals";
import { MEDICAL_REVIEWER, base_url } from "../../utilities";
import Loader from "../ReusableComp/Loader";

const MedicalReviewerUserManual = () => {
  const [loading, setLoadingg] = useState(false);
  const rowsToRender = [];
  tableData?.map((elem) => {
    if (elem.Role_code == MEDICAL_REVIEWER) {
      rowsToRender.push(elem);
    }
  });
  const fetchImages = async (document_url) => {
    if (document_url != null && document_url !== "") {
      setLoadingg(true);
      const queryParams = `?url=${document_url}`;
      const response = await fetch(base_url + "api/getImage" + queryParams);
      const data = await response.arrayBuffer();
      const base64 = btoa(
        new Uint8Array(data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      );
      setLoadingg(false);
      return `data:${response.headers.get("content-type")};base64,${base64}`;
    }
  };

  const downloadFile = async (document_url, typeOfDoc, user_Manual) => {
    const user_Url = await fetchImages(document_url);

    if (user_Url) {
      const validDocumentTypes = ["pdf"];

      if (validDocumentTypes.includes(typeOfDoc)) {
        try {
          const response = await fetch(user_Url);
          if (!response.ok) {
            throw new Error(
              `Failed to fetch file. HTTP status: ${response.status}`
            );
          }

          const blob = await response.blob();
          const blobUrl = window.URL.createObjectURL(blob);

          const downloadLink = document.createElement("a");
          downloadLink.href = blobUrl;
          downloadLink.download = user_Manual;

          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
          console.error("Error fetching or downloading file:", error);
        }
      }
    }
  };

  return (
    <div>
      {/* Navigation Bar */}
      <NavigationBar studyDropdwn={true} title={"User Manuals"} />

      <div className="main_body" style={{ marginTop: "100px" }}>
        {/* Container for the table */}
        <Container fluid className="pitable_container mt-2">
          {/* Search Bar */}

          {/* Table Section */}
          {
            <div
              className="table-scroll-container"
              style={{ border: "1px solid #E1E5E7 " }}
            >
              <Table bordered size="sm" className="pitable mb-0">
                {/* Table Header */}
                <thead className="sticky_table_header">
                  <tr>
                    <th>S.NO</th>
                    <th>User persona</th>
                    <th>User Manuals</th>
                    <th>Action</th>
                  </tr>
                </thead>

                {/* Table Body */}
                <tbody>
                  {rowsToRender.map((row, index) => (
                    <tr key={index + 1} className="text_center_table">
                      <td>{index + 1}</td>
                      <td>{row["user_Persona"]}</td>
                      <td>{row["user_Manual"]}</td>
                      <td className="d-flex justify-content-center align-items-center">
                        <img
                          height="30px"
                          width="40px"
                          src="./images/icons/reshot-icon-pdf.svg"
                          title="Click on the icon to download the file"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            downloadFile(
                              row?.user_Url,
                              "pdf",
                              row?.user_Manual
                            );
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          }
        </Container>
      </div>

      {/* Loader */}
      {loading && <Loader />}
    </div>
  );
};

export default MedicalReviewerUserManual;